import { useEffect, useRef } from 'react';

// Exit fullscreen when an overlay opens. SUI dialogs/sheets portal to document.body,
// which the Fullscreen API never renders, so they'd be invisible inside fullscreen.
export const useExitFullscreenOnOpen = (isOpen: boolean) => {
  const prevIsOpenRef = useRef(false);
  useEffect(() => {
    const wasOpen = prevIsOpenRef.current;
    prevIsOpenRef.current = isOpen;
    if (!wasOpen && isOpen && document.fullscreenElement) {
      document.exitFullscreen().catch(() => {});
    }
  }, [isOpen]);
};
